import { gql } from '@apollo/client';
import { TaxFragment } from 'graphql/Tax/fragments/TaxFragment';
/**
 * @fragment DealTaxFragment
 * @since 1.0.0
 */
export const DealTaxFragment = gql `
  fragment DealTaxFragment on DealTax {
    id
    rate
    value
    createdAt
    updatedAt
    tax {
      ...TaxFragment
    }
  }

  ${TaxFragment}
`;
